import React from "react";

const TermsService = () => {
    return (
        <div>
            <style>{`
        .tos-container {
          max-width: 800px;
          margin: 50px auto;
          padding: 20px;
          font-family: Arial, sans-serif;
          line-height: 1.6;
          color: #333;
        }

        .tos-header {
          color: #28a745;
          text-align: center;
          margin-bottom: 30px;
          font-size: 2rem;
        }

        .section-title {
          color: #28a745;
          margin-top: 20px;
          margin-bottom: 10px;
          font-size: 1.5rem;
        }

        .paragraph {
          margin-bottom: 15px;
          font-size: 1rem;
        }

        @media (max-width: 600px) {
          .tos-container {
            padding: 15px;
            margin: 20px auto;
          }

          .tos-header {
            font-size: 1.5rem;
          }

          .section-title {
            font-size: 1.25rem;
          }

          .paragraph {
            font-size: 0.95rem;
          }
        }
      `}</style>

            <div className="tos-container">
                <h1 className="tos-header">Terms of Service</h1>

                <h2 className="section-title">1. Acceptance of Terms</h2>
                <p className="paragraph">
                    By using our grocery website, you agree to comply with and be bound by these Terms of Service.
                </p>

                <h2 className="section-title">2. Use of the Website</h2>
                <p className="paragraph">
                    You agree to use the website only for lawful purposes and in a way that does not infringe the rights of others.
                </p>

                <h2 className="section-title">3. Account Responsibility</h2>
                <p className="paragraph">
                    You are responsible for maintaining the confidentiality of your login information and all activities under your account.
                </p>

                <h2 className="section-title">4. Product Information</h2>
                <p className="paragraph">
                    We strive for accurate product info but cannot guarantee completeness or currency.
                </p>

                <h2 className="section-title">5. Limitation of Liability</h2>
                <p className="paragraph">
                    We are not liable for any direct or indirect damages arising from your use of the website or purchased products.
                </p>

                <h2 className="section-title">6. Changes to Terms</h2>
                <p className="paragraph">
                    Changes may be posted here. Continued use indicates acceptance of updated terms.
                </p>

                <h2 className="section-title">7. Contact Us</h2>
                <p className="paragraph">
                    For questions, contact us at support@grocerywebsite.com.
                </p>
            </div>
        </div>
    );
};

export default TermsService;
